import React from 'react';
import { css } from '@emotion/core';

import { PrimaryType } from '@/meta';

/* FIXME: Cleanup: verify if this file still needs to be around */

export type APIKey =
  | 'name'
  | 'owner'
  | 'incident'
  | 'slos'
  | 'type'
  | 'impactDuration'
  | 'status'
  | 'description'
  | 'breaches'
  | 'start'
  | 'end'
  | PrimaryType;

const name = {
  content: 'Name',
  key: 'name',
} as const;

const team = {
  content: 'Team',
  key: 'team',
} as const;

const owner = {
  content: 'Owner',
  key: 'owner',
  width: 15,
} as const;

const breaches = {
  content: (
    <div
      css={css`
        text-align: center;
      `}
    >
      Breaching SLOs
    </div>
  ),
  width: 25,
  key: 'breaches',
} as const;

const product = {
  content: 'Product',
  key: 'product',
} as const;

const start = {
  content: 'Start (UTC)',
  key: 'start',
} as const;

const end = {
  content: 'End (UTC)',
  key: 'end' as const,
} as const;

const annotation = {
  content: 'Note',
  key: 'annotation' as const,
} as const;

const rate = {
  content: 'Rate',
  key: 'type' as const,
} as const;

export type FieldsType = { [key: string]: { key: string; content: any }[] };

export const fields: FieldsType = {
  breaches: [start, end, annotation],
  burnRateAlerts: [start, end, rate, annotation],
  sfxBreaches: [start, end, annotation],
  sfxBurns: [start, end, annotation],
  sfxBurnsExtended: [start, end, rate, annotation],
  product: [name, breaches],
  capability: [name, team, product, owner, { ...breaches }],
  team: [name, breaches],
  slo: [name],
  sloBreaches: [name, start, end],
};
